import React from 'react';
import Box from '@mui/material/Box';
import { LineChart } from '@mui/x-charts/LineChart';
import { WebsiteDailyCountSummary } from '../dataObjects/WebsiteDailyCountSummary';

const margin = { right: 24 };

interface dailyCountSummaryProps {
    summary?: WebsiteDailyCountSummary[];
}


const WebsiteDailyChart = (props: dailyCountSummaryProps) => {

    let usersData: number[] = [];
    let pageViewsData: number[] = [];
    let dates: string[] = [];

    if (props.summary) {
        let summary = props.summary;
        summary.forEach((data) => {
            usersData.push(data.activeUsers);
            pageViewsData.push(data.pageViews);
            dates.push(data.date);
            }
        );
    }

    return (
        <Box sx={{ width: '100%', height: 300 }}>
            <LineChart
                series={[
                    { data: usersData, label: 'Active Users' },
                    { data: pageViewsData, label: 'Page Views' },
                ]}
                xAxis={[{ scaleType: 'point', data: dates }]}
                margin={margin}
            />
        </Box>
    );
}

export default WebsiteDailyChart